import { render } from "./CustomTagsAndFieldsRichText.vue?vue&type=template&id=a027623e&scoped=true"
import script from "./CustomTagsAndFieldsRichText.vue?vue&type=script&lang=js"
export * from "./CustomTagsAndFieldsRichText.vue?vue&type=script&lang=js"

import "./CustomTagsAndFieldsRichText.vue?vue&type=style&index=0&id=a027623e&lang=scss"
import "./CustomTagsAndFieldsRichText.vue?vue&type=style&index=1&id=a027623e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a027623e"]])

export default __exports__